import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { style } from './selectable.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


/**
 * @slot - allows HTML content
 *
 * @summary This is a Selectable element
 */

export const selectableSizes = ['default', 'small', 'extraSmall'] as const
export type selectableSizeTypes = typeof selectableSizes

@customElement('cse-selectable')
export class CSESelectable extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String })
  state: 'selectable' | 'selected' | 'loading' | 'disabled' = 'selectable'

  @property({ type: String })
  fit: 'auto' | 'fill' = 'auto'

  @property({ type: String })
  size: selectableSizeTypes[number] = 'default'

  override render() {
    return html`
      <button
        class=${classMap({
          'cse-selectable': true,
          [this.state]: true,
          'fill': this.fit === 'fill',
          'size-small': this.size === 'small',
          'size-extra-small': this.size === 'extraSmall',
        })}
        tabindex="${this.state==='disabled' ? -1 : 0}"
        role="option"
        aria-selected="${this.state === 'selected'}"
        aria-busy="${this.state === 'loading'}"
        ?disabled=${this.state === 'disabled'}
      >
        <div class="overlay">
          <cse-loader animated></cse-loader>
        </div>
        <slot></slot>
      </button>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-selectable': CSESelectable
  }
}
